import React, { useState } from "react";
import Modal from "../../../UI/Modal";
import Icon from "../../../UI/Icon";
import { Button } from "../../../UI/Primitives";
import banner1 from "./../../../../assets/ac-services/banner1.jpg";
import banner2 from "./../../../../assets/ac-services/banner2.jpg";

const pricingItems = [
  { title: "AC Service", price: "₹499" },
  { title: "Installation - Window AC", price: "₹899" },
  { title: "Installation - Split AC", price: "₹1,399" },
  { title: "Uninstall - Window AC", price: "₹599" },
  { title: "Uninstall - Split AC", price: "₹799" },
  { title: "AC Visit (Inspection Only)", price: "₹299" },
  { title: "Gas Refill & Check", price: "₹2,749", badge: "45 Days Warranty" },
  { title: "AMC - Comprehensive", price: "₹3,499 / Year" },
  { title: "AMC - Non-Comprehensive", price: "₹1,999 / Year" },
];

const trustPoints = [
  "Certified & experienced AC technicians",
  "On-time doorstep service",
  "Transparent pricing - no hidden charges",
  "Warranty on gas refill services",
];

const heroPhone = "9318397171";
const secondaryPhone = "9625049297";

function ACServicesBanner() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="v-ac" aria-labelledby="v-ac-title">
      <div className="v-ac__copy">
        <span className="v-eyebrow">Voorent AC services</span>
        <h2 id="v-ac-title" className="v-ac__title">AC services at your doorstep</h2>
        <p className="v-ac__text">
          Expert AC repair, installation, servicing and AMC plans with transparent pricing. Service visits start at ₹499.
        </p>
        <div className="v-ac__actions">
          <Button variant="primary" onClick={() => setIsOpen(true)} aria-haspopup="dialog">
            View services &amp; pricing
          </Button>
          <Button variant="secondary" href={`tel:${heroPhone}`} icon="phone">
            Call {heroPhone}
          </Button>
        </div>
      </div>
      <button type="button" className="v-ac__media" onClick={() => setIsOpen(true)} aria-label="View AC services and pricing">
        <img src={banner2} alt="Voorent AC repair, installation and maintenance" width="1600" height="511" loading="lazy" decoding="async" />
      </button>

      <Modal open={isOpen} onClose={() => setIsOpen(false)} title="AC services & pricing" className="v-ac-modal">
        <img className="v-ac-modal__banner" src={banner1} alt="" width="1600" height="510" decoding="async" />
        <p className="v-muted">Expert AC repair, installation, servicing &amp; AMC plans with transparent pricing.</p>
        <ul className="v-ac-modal__prices">
          {pricingItems.map((item) => (
            <li key={item.title}>
              <span>{item.title}</span>
              <strong>{item.price}</strong>
              {item.badge ? <span className="v-badge v-badge--success">{item.badge}</span> : null}
            </li>
          ))}
        </ul>
        <p className="v-ac-modal__note">Note: 18% GST charges applicable apart from the above prices.</p>
        <h3 className="v-ac-modal__sub">Why customers choose Voorent AC services</h3>
        <ul className="v-ac-modal__trust">
          {trustPoints.map((point) => (
            <li key={point}>
              <Icon name="check" size={16} /> {point}
            </li>
          ))}
        </ul>
        <div className="v-ac-modal__cta">
          <Button variant="primary" href={`tel:${heroPhone}`} block>
            Book a service · {heroPhone}
          </Button>
          <Button variant="secondary" href={`tel:${secondaryPhone}`} block>
            Call {secondaryPhone}
          </Button>
        </div>
      </Modal>
    </section>
  );
}

export default ACServicesBanner;
